<template>
  <div>
    <el-card shadow="nerver">
      <div class="filter-area">
        <!-- 目的地 -->
        <div>
          <select-dest placeholder="所属目的地"
                       @selectDest="selectDest"></select-dest>
        </div>

        <!-- 搜索 -->
        <el-input size="mini"
                  style="width:20%;margin-left:20px"
                  placeholder="请输入搜索内容"
                  v-model="searchContentKeyword"
                  clearable>
          <el-button slot="append"
                     @click="searchButton"
                     icon="el-icon-search"></el-button>
        </el-input>
        <!-- 新建 -->
        <el-button @click="creatNewTraverPoint"
                   style="margin-left:auto"
                   size="mini"
                   type="primary">新建迹点</el-button>
      </div>
    </el-card>
    <el-card shadow="nerver"
             :style="bodyStyle"
             v-loading="loading">
      <cards-list-for-traver :imageHeight="147"
                             cardWidth="23%"
                             buttonName="查看"
                             titleMiniName=""
                             :showDest="false"
                             @clickButton="clickButtonEditor"
                             :cardList="content_list"></cards-list-for-traver>
      <!-- ----------------- 分页 ------------------ -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>
    </el-card>

  </div>
</template>

<script>
import { createLogger } from 'vuex'
import CardsListForTraver from '../../components/common/cards/CardsListForTraver'
import SelectDest from '../../components/common/select/SelectDest'

let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 150
export default {
  name: 'traver_point_list',
  components: {
    'cards-list-for-traver': CardsListForTraver,

    'select-dest': SelectDest,
  },
  data() {
    return {
      loading: false,
      bodyStyle: `min-height: ${contentHeight}px`,
      content_list: [],
      dest: '',
      traver_class: '',
      searchContentKeyword: '',
      // 分页
      pagenum_system: 1, // 当前页
      pagesize: 12, // 每页容量，自行设定
      page_account: null,
    }
  },
  mounted() {
    this.getTraverPointList()
  },
  methods: {
    // 选择目的地
    selectDest(dest) {
      // console.log(dest)
      if (dest == null) {
        this.dest = ''
      } else {
        this.dest = dest
      }
    },
    //  搜索按钮
    searchButton() {
      this.content_list = []
      this.getTraverPointList()
    },
    //   创建迹点
    creatNewTraverPoint() {
      //   1.添加一个迹点名
      this.$prompt('请输入创建的迹点名称：', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(({ value }) => {
          // console.log(value);
          //  2.创建
          this.$http
            .get(`/add_traver_point?traver_name=${value}`)
            .then((res) => {
              // 3.跳转到check 迹点叶敏啊
              // console.log(res);
              if (res.data.errno == 0) {
                this.$router.push(
                  `/check_traver_point?traver_id=${res.data.id}`
                )
              } else {
                this.$message({
                  type: 'info',
                  message: res.data.errmsg,
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消创建',
          })
        })
    },
    handleCurrentChange_system(page) {
      this.content_list = []
      this.pagenum_system = page
      this.getTraverPointList()
    }, // 获取迹点列表
    getTraverPointList() {
      this.loading = true
      this.$http
        .get(
          `/traver/get_traver_point_list?source_map=2&traver_title=${this.searchContentKeyword}&dest=${this.dest}&traver_class=${this.traver_class}&p_num=${this.pagenum_system}&p_size=${this.pagesize}`
        )
        .then((res) => {
          console.log(res)
          this.page_account = res.data.item_account
          if (res.data.errno == '0') {
            let list = res.data.data
            list.forEach((i) => {
              let item = {
                id: i.id,
                title: i.traver_title,
                title_mini: i.traver_info,
                image: i.traver_cover,
                corner_name: i.dest,
                update_time: i.update_time,
                class_name: i.traver_class,
              }
              this.content_list.push(item)
            })
            this.loading = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 编辑迹点
    clickButtonEditor(item) {
      // console.log(item)
      const newpage = this.$router.resolve({
        name: 'check_traver_point',
        query: {
          traver_id: item.id,
        },
      })
      window.open(newpage.href, '_blank')

      // this.$router.push(`?traver_id=${item.id}`)
    },
  },
}
</script>

<style>
.filter-area {
  display: flex;
}
.pagination {
  text-align: right;
  margin-top: 10px;
}
</style>